import React, { useState, useEffect, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
    clssInfo,
    getIstQuarter,
    getIIndQuarter,
    getIIIrdQuarter,
    getIVthQuarter,
    getVthQuarter,
    getVIthQuarter,
    CreateDialy,
    CreateRepoCard,
    CreateDailyConcept,
    CreateRepoCardConcept,
    closeBimesterDiary,
    reOpenBimesterDiary,
    getSchoolYear,
    RefreshAnnualForms,
    getClassSchedule
} from '../../Api'

import {
    Container,
    ContainerDivs,
    Header,
    HeaderTop,
    HeaderInfo,
    SchoolTag,
    Title,
    Subtitle,
    MetaRow,
    MetaChip,
    HeaderActions,
    EditButton,
    SectionLabel,
    Card,
    CardHead,
    CardTitle,
    CountTag,
    QuickLinks,
    LinkPill,
    PeopleList,
    PersonRow,
    StatusBadge,
    EmptyHint,
    ManageRow,
    Btt02,
    AddBtn,
    RemoveBtn,
    DiaryWrapper,
    DiaryGrid,
    DiaryBimester,
    FinalCard,
    StatusLine,
    TeacherStatus,
    StateChip,
    MiniBtn,
    DiaryEmpty,
    SupervisorAddButtonContainer,
    SkeletonHero,
    SkeletonCard,
    SkeletonLine,
    Overlay,
    Modal,
    ModalTitle,
    ModalText,
    ModalActions,
    ConfirmButton,
    ConfirmDanger,
    CancelButton,
    SelectList,
    FieldGroup,
    Label,
    Select,
} from './style';

/* iniciais para o avatar */
const initials = (name = '') =>
    name.trim().split(/\s+/).slice(0, 2).map(n => n[0] || '').join('') || '?';

const Cla$$Info = () => {

    const navigate = useNavigate()
    const currentYear = new Date().getFullYear().toString();
    const [year, setyear] = useState('');
    const [clss, setClss] = useState([])
    const [DailyClass, setDailyClass] = useState([])
    const [positionAtEducationDepartment, setPositionAtEducationDepartment] = useState('')
    const [positionAtSchool, setPositionAtSchool] = useState(null);
    const [assessmentFormat, setassessmentFormat] = useState('');
    const [yearclss, setyearclss] = useState('')
    const [classRegentEmployee, setclassRegentEmployee] = useState([])
    const [classRegentEmployee02, setclassRegentEmployee02] = useState([])
    const [physicalEducationTeacher, setphysicalEducationTeacher] = useState([])

    const [studentTransfer, setstudentTransfer] = useState()
    const [studentTransferMap, setstudentTransferMap] = useState([])

    const [nameSchool, setnameSchool] = useState([])

    const [stdt, setStdt] = useState([])

    const [bimonthly, setBimonthly] = useState([]);

    const [confirmClose, setConfirmClose] = useState(false);
    const [bimesterToClose, setBimesterToClose] = useState(null);
    const [fieldToClose, setFieldToClose] = useState(null);
    const [confirmReopen, setConfirmReopen] = useState(false);
    const [bimesterToReopen, setBimesterToReopen] = useState(null);
    const [fieldToReopen, setFieldToReopen] = useState(null);

    const [showRemoveTeacherModal, setShowRemoveTeacherModal] = useState(false);
    const [showRemoveTeacher02Modal, setShowRemoveTeacher02Modal] = useState(false);
    const [showRemovePhysicalTeacherModal, setShowRemovePhysicalTeacherModal] = useState(false);

    const [showAlert, setShowAlert] = useState(false);

    const [openModal, setOpenModal] = useState(false);
    const [selectedAction, setSelectedAction] = useState('');

    const [confirmModal, setConfirmModal] = useState(false);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);

    const [AllBimBull, setBimAllBull] = useState(false);

    const [loading, setLoading] = useState(false);
    const { id_class } = useParams();

    const [assessmentRegime, setAssessmentRegime] = useState('');

    const [bimesterLoading, setBimesterLoading] = useState(true);

    // grade horária: undefined = carregando, null = sem horário, objeto = configurado
    const [grade, setGrade] = useState(undefined);
    const [pedirHorario, setPedirHorario] = useState(false);

    useEffect(() => {
        let cancelled = false;
        getClassSchedule(id_class)
            .then((r) => { if (!cancelled) setGrade(r?.data?.grade || null); })
            .catch(() => { if (!cancelled) setGrade(null); });
        return () => { cancelled = true; };
    }, [id_class]);

    // logo após adicionar regente / Ed. Física: se a turma ainda não tem horário, pede para configurar
    useEffect(() => {
        if (grade === undefined) return;
        let flag = null;
        try { flag = sessionStorage.getItem('pedir-horario'); sessionStorage.removeItem('pedir-horario'); } catch { /* ignore */ }
        if (flag && flag === String(id_class) && grade === null) setPedirHorario(true);
    }, [grade, id_class]);

    useEffect(() => {
        let cancelled = false; // evita setState se o usuário sair da página

        (async () => {
            setLoading(true);
            setBimesterLoading(true);

            sessionStorage.removeItem("Selectbimonthly");
            sessionStorage.removeItem("Selectmatt");

            const position = localStorage.getItem('position_at_school');
            const idSchoolRaw = sessionStorage.getItem("id-school");
            const idSchool = JSON.parse(idSchoolRaw);
            const nameSchool = sessionStorage.getItem('School');
            const positionAtEducationDepartment =
                localStorage.getItem("positionAtEducationDepartment");

            // ───────────────────────────────────────────────────────────────
            // FASE 1 — CRÍTICO: o que a página precisa pra aparecer.
            // getSchoolYear e clssInfo rodam EM PARALELO (não em série).
            // ───────────────────────────────────────────────────────────────
            const [schoolYear, res] = await Promise.all([
                getSchoolYear(idSchool),
                clssInfo(id_class)
            ]);

            if (cancelled) return;

            const first = res.data.data.find(r => r);

            // Formato (nota/conceito) é por ESCOLA, definido no login.
            // Dentro da mesma sessão o sessionStorage é sempre correto.
            const resolvedFormat = sessionStorage.getItem('assessmentFormat') || '';

            const Daily = first.dailyStatus;
            const transferStdtMap = first.transferStudents;
            const Transfer = transferStdtMap.map(r => r._id);
            const $yearClass = res.data.data.find(c => c.year);

            const student = [
                ...new Map(
                    first.id_student
                        .filter(r => r.id_class.includes(id_class))
                        .map(r => [r._id, r])
                ).values()
            ];

            const classRegentEmployee = first.classRegentTeacher
                .map(r => (r ? r : null));
            const classRegentEmployee02 = first.classRegentTeacher02
                .map(r => (r ? r : null));
            const physicalEducationTeacher = first.physicalEducationTeacher
                .map(r => (r ? r : null));

            // Aplica o estado crítico
            setPositionAtSchool(position);
            setassessmentFormat(resolvedFormat);
            setyear(schoolYear.data.data);
            setnameSchool(nameSchool);
            setPositionAtEducationDepartment(positionAtEducationDepartment);
            setDailyClass(Daily);
            setClss(res.data.data);
            setstudentTransferMap(transferStdtMap);
            setstudentTransfer(Transfer);
            setyearclss($yearClass);
            setStdt(student);
            setclassRegentEmployee(classRegentEmployee);
            setclassRegentEmployee02(classRegentEmployee02);
            setphysicalEducationTeacher(physicalEducationTeacher);

            // ✅ A PÁGINA JÁ PODE APARECER AQUI
            setLoading(false);

            // ───────────────────────────────────────────────────────────────
            // FASE 2 — ADIADO: bimestres/regime. Só alimenta o dropdown de
            // boletins e o filtro trimestral. Roda DEPOIS, em segundo plano,
            // e as 6 chamadas vão TODAS EM PARALELO.
            // ───────────────────────────────────────────────────────────────
            try {
                const ano = $yearClass.year;

                const [
                    IstQuarter,
                    IIndQuarter,
                    IIIrdQuarter,
                    IVthQuarter,
                    VthQuarter,
                    VIthQuarter
                ] = await Promise.all([
                    getIstQuarter(ano, idSchool),
                    getIIndQuarter(ano, idSchool),
                    getIIIrdQuarter(ano, idSchool),
                    getIVthQuarter(ano, idSchool),
                    getVthQuarter(ano, idSchool),
                    getVIthQuarter(ano, idSchool)
                ]);

                if (cancelled) return;

                const i = IstQuarter.data.data.find(r => r) || null;
                const ii = IIndQuarter.data.data.find(r => r) || null;
                const iii = IIIrdQuarter.data.data.find(r => r) || null;
                const iv = IVthQuarter.data.data.find(r => r) || null;
                const v = VthQuarter.data.data.find(r => r) || null;
                const vi = VIthQuarter.data.data.find(r => r) || null;

                setAssessmentRegime(i?.assessmentRegime);
                setBimonthly([i, ii, iii, iv, v, vi].filter(r => r !== null));
            } catch (e) {
                console.log("Falha ao carregar bimestres:", e);
            } finally {
                if (!cancelled) setBimesterLoading(false);
            }
        })();

        return () => { cancelled = true; };

        // ⚠️ 'year' FOI REMOVIDO das dependências de propósito.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id_class]);

    // ── listas ordenadas memoizadas (evita re-sort a cada render) ──
    const sortedStudents = useMemo(
        () => [...stdt].sort((a, b) => a.name.localeCompare(b.name)),
        [stdt]
    );
    const sortedTransfers = useMemo(
        () => [...studentTransferMap].sort((a, b) => a.name.localeCompare(b.name)),
        [studentTransferMap]
    );

    const addStudent = async () => {
        sessionStorage.setItem("studentTransfer", studentTransfer)
        navigate('/add/student')
    }
    const ReassignStdt = async () => {
        sessionStorage.setItem("idClassTransfer", id_class)
        navigate('/reassign-student')
    }

    const TransferStdt = async () => {
        navigate('/transfer-student')
    }

    const addTeacher = async () => {
        navigate(`/add/teacher/${id_class}`)
    }
    const addTeacher02 = async () => {
        navigate(`/add/teacher02/${id_class}`)
    }
    const addPhysicalTeacher = async () => {
        navigate(`/add/physicalteacher/${id_class}`)
    }
    const handleAskRemoveTeacher = () => {
        setShowRemoveTeacherModal(true);
    };

    const handleAskRemoveTeacher02 = () => {
        setShowRemoveTeacher02Modal(true);
    };

    const handleAskRemovePhysicalTeacher = () => {
        setShowRemovePhysicalTeacherModal(true);
    };

    const RemoveTeacher = async () => {
        navigate('/remove/teacher')
    }
    const RemoveTeacher02 = async () => {
        navigate('/remove/teacher02')
    }
    const RemovephysicalTeacher = async () => {
        navigate('/remove/physicalteacher')
    }

    const RemoveStudent = async () => {
        navigate('/remove/student')
    }

    const Edit = async () => {
        navigate('/edit-class')
    }

    const handleEmployee = async (emp) => {
        sessionStorage.setItem("EmployeeInformation", emp._id)
        navigate(`/employee/info/${emp._id}`)
    }

    const handlephysicalEmp = async (physicalEmp) => {
        sessionStorage.setItem("EmployeeInformation", physicalEmp._id)
        navigate(`/employee/info/${physicalEmp._id}`)
    }

    const StudentInformation = async (stdt) => {
        setLoading(true);
        navigate(`/student/info/${stdt._id}`)
        setLoading(false);
    }

    const PrintableAttendanceSheet = async () => {
        setLoading(true);
        const serie = clss.map(clss => {
            return clss.serie
        })
        const nameClass = clss.map(clss => {
            return clss.name
        })
        navigate('/printable-attendance-sheet', {
            state: {
                students: stdt,
                schoolName: nameSchool,
                className: nameClass,
                serie: serie,
                teacherName: classRegentEmployee
            }
        });
        setLoading(false);
    }

    const PrintableAllTheBulletinsGrades = async () => {
        setBimAllBull(true)
    }

    // Garante que o formato (nota/conceito) está resolvido antes de navegar.
    const ensureFormat = () => {
        if (assessmentFormat === 'grade' || assessmentFormat === 'concept') {
            return assessmentFormat;
        }
        alert('Não foi possível identificar o tipo de avaliação desta turma (nota ou conceito). Recarregue a página antes de continuar.');
        return null;
    };

    const handleBimonthlyChange = (e) => {

        const value = e.target.value;

        if (value === "FinalConcepts") {
            const fmt = ensureFormat();
            if (!fmt) return;
            if (fmt === 'grade') {
                navigate(`/allTheFinalBulletins-grades/${id_class}`)
            }
            if (fmt === 'concept') {
                navigate(`/allTheFinalBulletins-concept/${id_class}`)
            }
            return; // para não continuar o código abaixo
        }

        if (!value) return;

        const selectedBimonthly = JSON.parse(e.target.value);
        const idBim = selectedBimonthly._id

        const fmt = ensureFormat();
        if (!fmt) return;

        if (fmt === 'grade') {
            if (selectedBimonthly.bimonthly === "1º BIMESTRE") {
                navigate(`/Ist-allTheBulletins-grades/${id_class}/${idBim}`)
            }
            if (selectedBimonthly.bimonthly === "2º BIMESTRE") {
                navigate(`/IInd-allTheBulletins-grades/${id_class}/${idBim}`)
            }
            if (selectedBimonthly.bimonthly === "3º BIMESTRE") {
                navigate(`/IIIrd-allTheBulletins-grades/${id_class}/${idBim}`)
            }
            if (selectedBimonthly.bimonthly === "4º BIMESTRE") {
                navigate(`/IVth-allTheBulletins-grades/${id_class}/${idBim}`)
            }
        }

        if (fmt === 'concept') {
            if (selectedBimonthly.bimonthly === "1º BIMESTRE") {
                navigate(`/Ist-allTheBulletins-concept/${id_class}/${idBim}`)
            }
            if (selectedBimonthly.bimonthly === "2º BIMESTRE") {
                navigate(`/IInd-allTheBulletins-concept/${id_class}/${idBim}`)
            }
            if (selectedBimonthly.bimonthly === "3º BIMESTRE") {
                navigate(`/IIIrd-allTheBulletins-concept/${id_class}/${idBim}`)
            }
            if (selectedBimonthly.bimonthly === "4º BIMESTRE") {
                navigate(`/IVth-allTheBulletins-concept/${id_class}/${idBim}`)
            }
        }
    };

    const confirmCloseModal = (bimester, field) => {
        setBimesterToClose(bimester);
        setFieldToClose(field);
        setConfirmClose(true);
    };

    const confirmReopenModal = (bimester, field) => {
        setBimesterToReopen(bimester);
        setFieldToReopen(field);
        setConfirmReopen(true);
    };

    const handleClose = async (bimester, field) => {
        const fmt = ensureFormat();
        if (!fmt) return;

        setLoading(true);

        const Bimester = bimonthly.find(item => item.bimonthly === bimester);

        if (fmt === 'grade') {
            if (bimester === "1º BIMESTRE") {
                const createDaily = await CreateDialy({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iStQuarter: Bimester._id
                });
                const createCard = await CreateRepoCard({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iStQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(
                        id_class,
                        Bimester.bimonthly,
                        field
                    )
                    if (resClose) {
                        await RefreshAnnualForms(id_class, Bimester.year)
                        window.location.reload()
                    }
                }
            }
            if (bimester === "2º BIMESTRE") {
                const createDaily = await CreateDialy({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiNdQuarter: Bimester._id
                });
                const createCard = await CreateRepoCard({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiNdQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(
                        id_class,
                        Bimester.bimonthly,
                        field
                    )
                    if (resClose) {
                        await RefreshAnnualForms(id_class, Bimester.year)
                        window.location.reload()
                    }
                }
            }
            if (bimester === "3º BIMESTRE") {
                const createDaily = await CreateDialy({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiiRdQuarter: Bimester._id
                });
                const createCard = await CreateRepoCard({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiiRdQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(
                        id_class,
                        Bimester.bimonthly,
                        field
                    )
                    if (resClose) {
                        await RefreshAnnualForms(id_class, Bimester.year)
                        window.location.reload()
                    }
                }
            }
            if (bimester === "4º BIMESTRE") {
                const createDaily = await CreateDialy({
                    year: Bimester.year,
                    idClass: id_class,
                    id_ivThQuarter: Bimester._id
                });
                const createCard = await CreateRepoCard({
                    year: Bimester.year,
                    idClass: id_class,
                    id_ivThQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(
                        id_class,
                        Bimester.bimonthly,
                        field
                    )
                    if (resClose) {
                        await RefreshAnnualForms(id_class, Bimester.year)
                        window.location.reload()
                    }
                }
            }
        }

        if (fmt === 'concept') {
            if (bimester === "1º BIMESTRE") {
                const createDaily = await CreateDailyConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iStQuarter: Bimester._id
                });
                const createCard = await CreateRepoCardConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iStQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(id_class, Bimester.bimonthly, field)
                    if (resClose) {
                        window.location.reload()
                    }
                }
            }
            if (bimester === "2º BIMESTRE") {
                const createDaily = await CreateDailyConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiNdQuarter: Bimester._id
                });
                const createCard = await CreateRepoCardConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiNdQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(id_class, Bimester.bimonthly, field)
                    if (resClose) {
                        window.location.reload()
                    }
                }
            }
            if (bimester === "3º BIMESTRE") {
                const createDaily = await CreateDailyConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiiRdQuarter: Bimester._id
                });
                const createCard = await CreateRepoCardConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_iiiRdQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(id_class, Bimester.bimonthly, field)
                    if (resClose) {
                        window.location.reload()
                    }
                }
            }
            if (bimester === "4º BIMESTRE") {
                const createDaily = await CreateDailyConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_ivThQuarter: Bimester._id
                });
                const createCard = await CreateRepoCardConcept({
                    year: Bimester.year,
                    idClass: id_class,
                    id_ivThQuarter: Bimester._id
                });
                if (createDaily && createCard) {
                    const resClose = await closeBimesterDiary(id_class, Bimester.bimonthly, field)
                    if (resClose) {
                        window.location.reload()
                    }
                }
            }
        }
    };

    const reOpen = async (bimester, field) => {
        const Bimester = bimonthly.find(item => item.bimonthly === bimester);
        const reopen = await reOpenBimesterDiary(id_class, Bimester.bimonthly, field)
        if (reopen) {
            window.location.reload()
        }
    }

    const seeDiary = async (bimester) => {
        const Bimester = bimonthly.find(item => item.bimonthly === bimester);
        navigate(`/bimonthly-diary/${bimester}/${id_class}/${Bimester._id}`)
    }

    // diário ainda aberto: prévia com tudo o que já está gravado (marcada como PRÉVIA)
    const seePreview = (bimester) => {
        const Bimester = bimonthly.find(item => item.bimonthly === bimester);
        if (!Bimester) return;
        navigate(`/bimonthly-diary/${bimester}/${id_class}/${Bimester._id}?previa=1`)
    }

    // Modal de aviso de remoção de professor (agora no padrão do design system)
    const RemoveTeacherModal = ({ onClose, onConfirm }) => (
        <Overlay onClick={onClose}>
            <Modal onClick={(e) => e.stopPropagation()}>
                <ModalTitle $tone="danger">⚠️ Atenção!</ModalTitle>
                <ModalText className="danger">
                    Se o professor lecionou em algum bimestre, verifique antes de removê-lo
                    se todos os registros foram preenchidos corretamente e se o diário do
                    bimestre foi fechado. Lembre-se: o nome que fica registrado no diário é
                    sempre do professor que fecha o diário do bimestre.
                </ModalText>
                <ModalText className="danger" style={{ color: '#cf3a3a' }}>
                    Caso a turma tenha dois professores, é essencial manter pelo menos um deles
                    cadastrado como <strong>professor regente titular</strong>. O diário do{' '}
                    <strong>Professor Regente Adjunto</strong> só funcionará corretamente se
                    houver um regente titular vinculado à turma.
                </ModalText>
                <ModalActions>
                    <CancelButton onClick={onClose}>Cancelar</CancelButton>
                    <ConfirmDanger onClick={onConfirm}>Confirmar Remoção</ConfirmDanger>
                </ModalActions>
            </Modal>
        </Overlay>
    );

    const handleEmployeeClick = (employeeId) => {
        setSelectedEmployeeId(employeeId);
        setOpenModal(false);
        setConfirmModal(true);
    };

    const handleConfirm = () => {
        setConfirmModal(false);
        setOpenModal(false);
        handleSelectEmployee(selectedEmployeeId);
    };

    const handleCancelConfirm = () => {
        setConfirmModal(false);
    }

    const handleOpenModal = (action) => {
        setSelectedAction(action);
        setOpenModal(true);

        sessionStorage.setItem("class-info", id_class)

        sessionStorage.setItem(
            "classRegentTeacher",
            JSON.stringify(classRegentEmployee.find(emp => emp)._id)
        );

        const regent2 = classRegentEmployee02.find(emp => emp);
        if (regent2?._id) {
            sessionStorage.setItem("classRegentTeacher02", JSON.stringify(regent2._id));
        }

        const physical = physicalEducationTeacher.find(emp => emp);
        if (physical?._id) {
            sessionStorage.setItem("physicalEducationTeacher", JSON.stringify(physical._id));
        }

        sessionStorage.removeItem("Selectbimonthly");
    };

    const handleSelectEmployee = (employeeId) => {
        setOpenModal(false);

        switch (selectedAction) {
            case 'FREQUENCIA':
                navigate('/Supervisor-AllAttendances', { state: { employee: employeeId } });
                break;
            case 'AULAS':
                navigate('/Supervisor-classes', { state: { employee: employeeId } });
                break;
            case 'AVALIAÇÕES':
                navigate('/$superviso-activities', { state: { employee: employeeId } });
                break;
            case 'CONCEITOS':
                navigate('/$superviso-concepts', { state: { employee: employeeId } });
                break;
            case 'FICHA':
                navigate('/Supervisor-individual-report', { state: { employee: employeeId } });
                break;
            case 'CONCEITOS_FINAIS':
                navigate('/$Supervisor-final-concepts', { state: { employee: employeeId } });
                break;
            default:
                break;
        }
    };

    const getDiaryLabel = (rawBimester) => {
        if (assessmentRegime === 'TRIMESTRAL') {
            return rawBimester.replace('BIMESTRE', 'TRIMESTRE')
        }
        return rawBimester
    }

    const finalPeriodKey = assessmentRegime === 'TRIMESTRAL'
        ? '3º BIMESTRE'
        : '4º BIMESTRE';

    const finalPeriodStatus = DailyClass?.[finalPeriodKey];
    const isFinalClosed = finalPeriodStatus?.regentTeacher === "fechado";

    const goToFinalResult = () => {
        navigate(`/final-diary/${id_class}/${yearclss.year}`);
    };

    const canManage = !positionAtEducationDepartment && yearclss.year === JSON.stringify(year);
    const isSupervisorOrSecretary =
        positionAtSchool === 'DIRETOR/SUPERVISOR' || positionAtSchool === "SECRETARIO";

    const mainClass = clss[0];

    // ── SKELETON ──
    if (loading) {
        return (
            <Container>
                <ContainerDivs>
                    <SkeletonHero />
                    {[1, 2, 3].map((i) => (
                        <SkeletonCard key={i}>
                            <SkeletonLine $w="35%" $h="16px" />
                            <SkeletonLine $w="80%" />
                            <SkeletonLine $w="60%" />
                        </SkeletonCard>
                    ))}
                </ContainerDivs>
            </Container>
        );
    }

    return (
        <Container>
            <ContainerDivs>

                {/* ── HERO: informações principais da turma ── */}
                {mainClass && (
                    <Header>
                        <HeaderTop>
                            <HeaderInfo>
                                {nameSchool && <SchoolTag>🏫 {nameSchool}</SchoolTag>}
                                <Title>📚 {mainClass.name}</Title>
                                <Subtitle>{mainClass.serie} · {mainClass.level} · {mainClass.shift}</Subtitle>
                            </HeaderInfo>

                            {mainClass.year === currentYear && !positionAtEducationDepartment && (
                                <HeaderActions>
                                    <EditButton onClick={Edit}>✏️ Editar Turma</EditButton>
                                </HeaderActions>
                            )}
                        </HeaderTop>

                        <MetaRow>
                            <MetaChip><b>Ano</b> {mainClass.year}</MetaChip>
                            <MetaChip><b>Série</b> {mainClass.serie}</MetaChip>
                            <MetaChip><b>Turno</b> {mainClass.shift}</MetaChip>
                            <MetaChip><b>Etapa</b> {mainClass.level}</MetaChip>
                            <MetaChip><b>Código</b> {mainClass.classCode}</MetaChip>
                        </MetaRow>
                    </Header>
                )}

                {/* ── Ações do supervisor ── */}
                {yearclss.year === JSON.stringify(year) && !positionAtEducationDepartment &&
                    positionAtSchool === "DIRETOR/SUPERVISOR" && (
                        <>
                            <SectionLabel>Acesso do Supervisor</SectionLabel>
                            <SupervisorAddButtonContainer>
                                <button onClick={() => handleOpenModal('FREQUENCIA')}>🗓️ Frequências</button>
                                <button onClick={() => handleOpenModal('AULAS')}>📖 Aulas</button>
                                {assessmentFormat !== 'grade'
                                    ? <button onClick={() => handleOpenModal('CONCEITOS')}>🔤 Conceitos</button>
                                    : <button onClick={() => handleOpenModal('AVALIAÇÕES')}>📝 Avaliações</button>
                                }
                                {assessmentFormat === 'grade' && (
                                    <button onClick={() => navigate(`/recovery/${id_class}`)}>🔁 Recuperação</button>
                                )}
                                {assessmentFormat !== 'grade' && (
                                    <>
                                        <button onClick={() => handleOpenModal('FICHA')}>📋 Relatório Individual</button>
                                        <button onClick={() => handleOpenModal('CONCEITOS_FINAIS')}>🏆 Conceitos Finais</button>
                                    </>
                                )}
                            </SupervisorAddButtonContainer>
                        </>
                    )}

                {/* ── Diário da turma ── */}
                <SectionLabel>Diário da Turma</SectionLabel>
                <DiaryWrapper>
                    {Object.keys(DailyClass).length === 0 ? (
                        <DiaryEmpty>
                            <span className="em">📭</span>
                            Nenhum período registrado ainda.
                        </DiaryEmpty>
                    ) : (
                        <DiaryGrid>
                            {(() => {
                                const entries = Object.entries(DailyClass).filter(([rawBimester]) => {
                                    if (assessmentRegime === 'TRIMESTRAL') {
                                        return !rawBimester.includes('4º')
                                    }
                                    return true
                                });
                                // Se a quantidade de cards for ímpar, o último fica
                                // sozinho na última linha → centraliza ele (triângulo invertido).
                                const orphanLast = entries.length % 2 === 1;

                                return entries.map(([rawBimester, status], index) => {
                                    const showRegent = status.regentTeacher === "aberto" || status.regentTeacher === "fechado";
                                    const showPhysical = status.physicalEducationTeacher === "aberto" || status.physicalEducationTeacher === "fechado";
                                    const sameYear = yearclss.year === JSON.stringify(year);
                                    const isCentered = orphanLast && index === entries.length - 1;

                                    return (
                                        <DiaryBimester key={index} $centered={isCentered}>
                                            <h3>🗂️ {getDiaryLabel(rawBimester)}</h3>
                                            <StatusLine>
                                                {/* PROFESSOR REGENTE */}
                                                {showRegent && (
                                                    <TeacherStatus>
                                                        <div className="row">
                                                            <span className="role">Prof. Regente</span>
                                                            <StateChip $open={status.regentTeacher === "aberto"}>
                                                                {status.regentTeacher}
                                                            </StateChip>
                                                        </div>
                                                        <div className="btns">
                                                            {sameYear && status.regentTeacher === "aberto" && isSupervisorOrSecretary && (
                                                                <MiniBtn $variant="close" onClick={() => confirmCloseModal(rawBimester, "regentTeacher")}>
                                                                    🔒 Fechar
                                                                </MiniBtn>
                                                            )}
                                                            {status.regentTeacher === "aberto" && (
                                                                <MiniBtn $variant="preview" title="Diário ainda aberto: mostra o que já está gravado (prévia)" onClick={() => seePreview(rawBimester)}>
                                                                    👁️ Ver prévia
                                                                </MiniBtn>
                                                            )}
                                                            {status.regentTeacher === "fechado" && (
                                                                <>
                                                                    {sameYear && isSupervisorOrSecretary && (
                                                                        <MiniBtn $variant="reopen" onClick={() => confirmReopenModal(rawBimester, "regentTeacher")}>
                                                                            🔓 Reabrir
                                                                        </MiniBtn>
                                                                    )}
                                                                    <MiniBtn $variant="see" onClick={() => seeDiary(rawBimester)}>
                                                                        👁️ Ver Diário
                                                                    </MiniBtn>
                                                                </>
                                                            )}
                                                        </div>
                                                    </TeacherStatus>
                                                )}

                                                {/* PROFESSOR ED. FÍSICA */}
                                                {showPhysical && (
                                                    <TeacherStatus>
                                                        <div className="row">
                                                            <span className="role">Prof. Ed. Física</span>
                                                            <StateChip $open={status.physicalEducationTeacher === "aberto"}>
                                                                {status.physicalEducationTeacher}
                                                            </StateChip>
                                                        </div>
                                                        <div className="btns">
                                                            {sameYear && status.physicalEducationTeacher === "aberto" && isSupervisorOrSecretary && (
                                                                <MiniBtn $variant="close" onClick={() => confirmCloseModal(rawBimester, "physicalEducationTeacher")}>
                                                                    🔒 Fechar
                                                                </MiniBtn>
                                                            )}
                                                            {status.physicalEducationTeacher === "aberto" && (
                                                                <MiniBtn $variant="preview" title="Diário ainda aberto: mostra o que já está gravado (prévia)" onClick={() => seePreview(rawBimester)}>
                                                                    👁️ Ver prévia
                                                                </MiniBtn>
                                                            )}
                                                            {status.physicalEducationTeacher === "fechado" && (
                                                                <>
                                                                    {sameYear && isSupervisorOrSecretary && (
                                                                        <MiniBtn $variant="reopen" onClick={() => confirmReopenModal(rawBimester, "physicalEducationTeacher")}>
                                                                            🔓 Reabrir
                                                                        </MiniBtn>
                                                                    )}
                                                                    <MiniBtn $variant="see" onClick={() => seeDiary(rawBimester)}>
                                                                        👁️ Ver Diário
                                                                    </MiniBtn>
                                                                </>
                                                            )}
                                                        </div>
                                                    </TeacherStatus>
                                                )}
                                            </StatusLine>
                                        </DiaryBimester>
                                    );
                                });
                            })()}

                            {isFinalClosed && (
                                <FinalCard>
                                    <h3>🏆 Resultado Final</h3>
                                    <MiniBtn $variant="final" onClick={goToFinalResult}>
                                        ✔ Ver Resultado Final
                                    </MiniBtn>
                                </FinalCard>
                            )}
                        </DiaryGrid>
                    )}
                </DiaryWrapper>

                {/* ── Horário da turma ── */}
                <SectionLabel>Horário da Turma</SectionLabel>
                <Card>
                    <CardHead>
                        <CardTitle><span className="em">🕒</span> Grade horária</CardTitle>
                        {grade && <StatusBadge $tone="blue">Configurado</StatusBadge>}
                    </CardHead>
                    {grade === undefined ? (
                        <EmptyHint>Carregando…</EmptyHint>
                    ) : grade ? (
                        <EmptyHint>
                            <span className="em">✅</span>
                            <span>Os professores só lançam aulas e frequências nos dias em que têm aula no horário
                            {(() => {
                                const n = ['', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
                                const dias = (t) => [...new Set((grade.celulas || []).filter(c => c.tipo === t).map(c => c.dia))].sort().map(d => n[d]).join(', ') || '—';
                                return <> — Regente: <strong>{dias('REGENTE')}</strong> · Ed. Física: <strong>{dias('ED_FISICA')}</strong></>;
                            })()}
                            </span>
                        </EmptyHint>
                    ) : (
                        <div style={{ background: '#fff4e5', border: '1px solid #f59e0b', color: '#7c4a03', borderRadius: 10, padding: '10px 12px', fontSize: 14, margin: '4px 0 8px' }}>
                            ⚠️ <strong>Esta turma ainda não tem horário.</strong> Configure logo após adicionar os professores:
                            com o horário, cada professor só consegue lançar aulas e frequências nos dias em que tem aula nesta turma,
                            evitando lançamentos na turma ou no dia errado. Enquanto não houver horário, a turma funciona normalmente.
                        </div>
                    )}
                    <ManageRow>
                        {canManage && isSupervisorOrSecretary
                            ? <AddBtn onClick={() => navigate(`/class-schedule/${id_class}`)}>{grade ? '👁️ Ver / ✏️ Editar horário' : '🕒 Configurar horário'}</AddBtn>
                            : grade ? <AddBtn onClick={() => navigate(`/class-schedule/${id_class}`)}>👁️ Ver horário</AddBtn> : null}
                    </ManageRow>
                </Card>

                {/* ── Equipe ── */}
                <SectionLabel>Equipe Docente</SectionLabel>

                {/* PROFESSOR REGENTE TITULAR */}
                <Card>
                    <CardHead>
                        <CardTitle><span className="em">👨‍🏫</span> Professor Regente Titular</CardTitle>
                    </CardHead>

                    {classRegentEmployee.length > 0 ? (
                        <>
                            {canManage && (
                                <ManageRow>
                                    <RemoveBtn onClick={handleAskRemoveTeacher}>🗑️ Remover</RemoveBtn>
                                </ManageRow>
                            )}
                            <PeopleList>
                                {classRegentEmployee.map(emp => (
                                    <PersonRow onClick={() => handleEmployee(emp)} key={emp._id}>
                                        <span className="avatar">{initials(emp.name)}</span>
                                        <span className="name">{emp.name}</span>
                                        <span className="chev">›</span>
                                    </PersonRow>
                                ))}
                            </PeopleList>
                            {showRemoveTeacherModal && (
                                <RemoveTeacherModal
                                    onClose={() => setShowRemoveTeacherModal(false)}
                                    onConfirm={RemoveTeacher}
                                />
                            )}
                        </>
                    ) : (
                        <>
                            {canManage && (
                                <ManageRow>
                                    <AddBtn onClick={addTeacher}>＋ Adicionar</AddBtn>
                                </ManageRow>
                            )}
                            <EmptyHint><span className="em">🔍</span> Não há nenhum professor.</EmptyHint>
                        </>
                    )}
                </Card>

                {/* PROFESSOR REGENTE ADJUNTO */}
                <Card>
                    <CardHead>
                        <CardTitle><span className="em">🧑‍🏫</span> Professor Regente Adjunto</CardTitle>
                    </CardHead>

                    {classRegentEmployee02.length > 0 ? (
                        <>
                            {canManage && (
                                <ManageRow>
                                    <RemoveBtn onClick={handleAskRemoveTeacher02}>🗑️ Remover</RemoveBtn>
                                </ManageRow>
                            )}
                            <PeopleList>
                                {classRegentEmployee02.map(emp => (
                                    <PersonRow onClick={() => handleEmployee(emp)} key={emp._id}>
                                        <span className="avatar">{initials(emp.name)}</span>
                                        <span className="name">{emp.name}</span>
                                        <span className="chev">›</span>
                                    </PersonRow>
                                ))}
                            </PeopleList>
                            {showRemoveTeacher02Modal && (
                                <RemoveTeacherModal
                                    onClose={() => setShowRemoveTeacher02Modal(false)}
                                    onConfirm={RemoveTeacher02}
                                />
                            )}
                        </>
                    ) : (
                        <>
                            {canManage && (
                                <ManageRow>
                                    <AddBtn onClick={addTeacher02}>＋ Adicionar</AddBtn>
                                </ManageRow>
                            )}
                            <EmptyHint><span className="em">🔍</span> Não há nenhum professor.</EmptyHint>
                        </>
                    )}
                </Card>

                {/* PROFESSOR DE ED. FÍSICA */}
                <Card>
                    <CardHead>
                        <CardTitle><span className="em">⚽</span> Professor de Educação Física</CardTitle>
                    </CardHead>

                    {physicalEducationTeacher.length > 0 ? (
                        <>
                            {canManage && (
                                <ManageRow>
                                    <RemoveBtn onClick={handleAskRemovePhysicalTeacher}>🗑️ Remover</RemoveBtn>
                                </ManageRow>
                            )}
                            <PeopleList>
                                {physicalEducationTeacher.map(physicalEmp => (
                                    <PersonRow onClick={() => handlephysicalEmp(physicalEmp)} key={physicalEmp._id}>
                                        <span className="avatar">{initials(physicalEmp.name)}</span>
                                        <span className="name">{physicalEmp.name}</span>
                                        <span className="chev">›</span>
                                    </PersonRow>
                                ))}
                            </PeopleList>
                            {showRemovePhysicalTeacherModal && (
                                <RemoveTeacherModal
                                    onClose={() => setShowRemovePhysicalTeacherModal(false)}
                                    onConfirm={RemovephysicalTeacher}
                                />
                            )}
                        </>
                    ) : (
                        <>
                            {canManage && (
                                <ManageRow>
                                    <AddBtn onClick={addPhysicalTeacher}>＋ Adicionar</AddBtn>
                                </ManageRow>
                            )}
                            <EmptyHint><span className="em">🔍</span> Não há nenhum professor.</EmptyHint>
                        </>
                    )}
                </Card>

                {/* ── Alunos ── */}
                <SectionLabel>Alunos</SectionLabel>
                {(stdt.length > 0 || studentTransferMap.length > 0) ? (
                    <Card>
                        <CardHead>
                            <CardTitle><span className="em">🎓</span> Alunos <CountTag>{stdt.length}</CountTag></CardTitle>
                        </CardHead>

                        <QuickLinks>
                            <LinkPill onClick={PrintableAttendanceSheet}>🖨️ Imprimir lista de alunos</LinkPill>
                            <LinkPill onClick={PrintableAllTheBulletinsGrades}>📄 Emitir boletins da turma</LinkPill>
                            <LinkPill onClick={() => navigate(`/occurrences/class/${id_class}`)}>📝 Ocorrências</LinkPill>
                        </QuickLinks>

                        {studentTransferMap.length > 0 && (
                            <EmptyHint style={{ borderStyle: 'solid' }}>
                                <span className="em">⚠️</span>
                                Total de alunos transferidos/remanejados: <strong>{studentTransferMap.length}</strong>
                            </EmptyHint>
                        )}

                        {yearclss.year === JSON.stringify(year) && !positionAtEducationDepartment && (
                            <ManageRow>
                                <AddBtn onClick={addStudent}>＋ Adicionar</AddBtn>
                                {stdt.length > 0 && (
                                    <>
                                        <Btt02 onClick={ReassignStdt}>🔁 Remanejar</Btt02>
                                        <Btt02 onClick={TransferStdt}>📤 Transferir</Btt02>
                                        <RemoveBtn onClick={RemoveStudent}>🗑️ Remover</RemoveBtn>
                                    </>
                                )}
                            </ManageRow>
                        )}

                        {stdt.length > 0 ? (
                            <PeopleList>
                                {sortedStudents.map(student => (
                                    <PersonRow key={student._id} onClick={() => StudentInformation(student)}>
                                        <span className="avatar">{initials(student.name)}</span>
                                        <span className="name">{student.name}</span>
                                        {student.status === "inativo" && <StatusBadge $tone="red">Inativo</StatusBadge>}
                                        <span className="chev">›</span>
                                    </PersonRow>
                                ))}
                            </PeopleList>
                        ) : (
                            <EmptyHint><span className="em">🔍</span> Não há alunos ativos nesta turma.</EmptyHint>
                        )}

                        {sortedTransfers.length > 0 && (
                            <>
                                <CardTitle style={{ fontSize: '13.5px', marginTop: '4px' }}>
                                    <span className="em">⚠️</span> Alunos Transferidos e Remanejados
                                </CardTitle>
                                <PeopleList>
                                    {sortedTransfers.map(student => (
                                        <PersonRow key={student._id} onClick={() => StudentInformation(student)}>
                                            <span className="avatar">{initials(student.name)}</span>
                                            <span className="name">{student.name}</span>
                                            {student.status === "ativo" && <StatusBadge $tone="blue">Remanejado</StatusBadge>}
                                            {student.status === "inativo" && <StatusBadge $tone="red">Inativo</StatusBadge>}
                                            {student.status === "transferido" && <StatusBadge $tone="amber">Transferido</StatusBadge>}
                                            <span className="chev">›</span>
                                        </PersonRow>
                                    ))}
                                </PeopleList>
                            </>
                        )}
                    </Card>
                ) : (
                    <Card>
                        <CardHead>
                            <CardTitle><span className="em">🎓</span> Alunos</CardTitle>
                        </CardHead>
                        {yearclss.year === JSON.stringify(year) && !positionAtEducationDepartment && (
                            <ManageRow>
                                <AddBtn onClick={addStudent}>＋ Adicionar Aluno</AddBtn>
                            </ManageRow>
                        )}
                        <EmptyHint><span className="em">🔍</span> Não há nenhum estudante.</EmptyHint>
                    </Card>
                )}

                {/* ── MODAIS ── */}

                {/* Logo após adicionar professor: configurar o horário */}
                {pedirHorario && canManage && isSupervisorOrSecretary && (
                    <Overlay onClick={() => setPedirHorario(false)}>
                        <Modal onClick={(e) => e.stopPropagation()}>
                            <ModalTitle>🕒 Configure o horário da turma</ModalTitle>
                            <ModalText>
                                Professor adicionado. Agora configure o <strong>horário desta turma</strong>, marcando os dias
                                de aula do regente e de Educação Física. Com o horário, cada professor só lança aulas e
                                frequências nos dias em que tem aula nesta turma.
                            </ModalText>
                            <ModalActions>
                                <CancelButton onClick={() => setPedirHorario(false)}>Depois</CancelButton>
                                <ConfirmButton onClick={() => navigate(`/class-schedule/${id_class}`)}>Configurar agora</ConfirmButton>
                            </ModalActions>
                        </Modal>
                    </Overlay>
                )}

                {/* Confirmação: acessar diário do funcionário (supervisor) */}
                {confirmModal && (
                    <Overlay onClick={handleCancelConfirm}>
                        <Modal onClick={(e) => e.stopPropagation()}>
                            <ModalTitle>📝 Confirmar</ModalTitle>
                            <ModalText style={{ textAlign: 'center' }}>
                                Tem certeza que deseja adicionar conteúdo no diário de{' '}
                                <strong>{selectedEmployee?.name}</strong>?
                            </ModalText>
                            <ModalActions>
                                <CancelButton onClick={handleCancelConfirm}>Não</CancelButton>
                                <ConfirmButton onClick={handleConfirm}>Sim</ConfirmButton>
                            </ModalActions>
                        </Modal>
                    </Overlay>
                )}

                {/* Selecionar funcionário (supervisor) */}
                {openModal && (
                    <Overlay onClick={() => setOpenModal(false)}>
                        <Modal onClick={(e) => e.stopPropagation()}>
                            <ModalTitle>👥 Selecione o funcionário</ModalTitle>
                            <SelectList>
                                {classRegentEmployee?.map(emp => (
                                    <li key={emp._id} onClick={() => {
                                        handleEmployeeClick(emp._id);
                                        setSelectedEmployee(emp);
                                    }}>
                                        <span className="avatar">{initials(emp.name)}</span>
                                        {emp.name}
                                    </li>
                                ))}
                                {physicalEducationTeacher?.map(emp => (
                                    <li key={emp._id} onClick={() => {
                                        handleEmployeeClick(emp._id);
                                        setSelectedEmployee(emp);
                                    }}>
                                        <span className="avatar">{initials(emp.name)}</span>
                                        {emp.name}
                                    </li>
                                ))}
                            </SelectList>
                            <ModalActions>
                                <CancelButton onClick={() => setOpenModal(false)}>Cancelar</CancelButton>
                            </ModalActions>
                        </Modal>
                    </Overlay>
                )}

                {/* Confirmar fechamento de bimestre */}
                {confirmClose && (
                    <Overlay onClick={() => setConfirmClose(false)}>
                        <Modal onClick={(e) => e.stopPropagation()}>
                            <ModalTitle>⚠️ Atenção</ModalTitle>
                            <ModalText>
                                Verifique se todas as informações estão completas.{' '}
                                <strong>O diário será fechado.</strong>
                            </ModalText>
                            <ModalActions>
                                <CancelButton onClick={() => setConfirmClose(false)}>Cancelar</CancelButton>
                                <ConfirmButton onClick={() => {
                                    setConfirmClose(false);
                                    handleClose(bimesterToClose, fieldToClose);
                                }}>
                                    Confirmar Fechamento
                                </ConfirmButton>
                            </ModalActions>
                        </Modal>
                    </Overlay>
                )}

                {/* Confirmar reabertura de bimestre */}
                {confirmReopen && (
                    <Overlay onClick={() => setConfirmReopen(false)}>
                        <Modal onClick={(e) => e.stopPropagation()}>
                            <ModalTitle>⚠️ Atenção</ModalTitle>
                            <ModalText>
                                O período será reaberto. Para visualizar o diário novamente,{' '}
                                <strong>será necessário fechá-lo depois.</strong>
                            </ModalText>
                            <ModalActions>
                                <CancelButton onClick={() => setConfirmReopen(false)}>Cancelar</CancelButton>
                                <ConfirmButton onClick={() => {
                                    setConfirmReopen(false);
                                    reOpen(bimesterToReopen, fieldToReopen);
                                }}>
                                    Confirmar Reabertura
                                </ConfirmButton>
                            </ModalActions>
                        </Modal>
                    </Overlay>
                )}

                {/* Alerta de diário completo */}
                {showAlert && (
                    <Overlay onClick={() => setShowAlert(false)}>
                        <Modal onClick={(e) => e.stopPropagation()}>
                            <ModalTitle>ℹ️ Aviso</ModalTitle>
                            <ModalText style={{ textAlign: 'center' }}>
                                Para visualizar o diário completo, é necessário que todos os
                                bimestres estejam fechados.
                            </ModalText>
                            <ModalActions>
                                <ConfirmButton onClick={() => setShowAlert(false)}>Ok</ConfirmButton>
                            </ModalActions>
                        </Modal>
                    </Overlay>
                )}

                {/* Modal de boletins da turma */}
                {AllBimBull && (
                    <Overlay onClick={() => setBimAllBull(false)}>
                        <Modal onClick={(e) => e.stopPropagation()}>
                            <ModalTitle>
                                📄 {assessmentRegime === 'TRIMESTRAL' ? 'Selecione o Trimestre' : 'Selecione o Bimestre'}
                            </ModalTitle>
                            <FieldGroup>
                                <Label>{assessmentRegime === 'TRIMESTRAL' ? 'Trimestre' : 'Bimestres'}</Label>
                                <Select id="id-bimonthly" onChange={handleBimonthlyChange} defaultValue="">
                                    <option value="">
                                        {bimesterLoading ? "Carregando períodos..." : "Selecione"}
                                    </option>
                                    {bimonthly
                                        .filter(res => {
                                            if (assessmentRegime === 'TRIMESTRAL') {
                                                return res.bimonthly !== '4º BIMESTRE';
                                            }
                                            return true;
                                        })
                                        .map(res => (
                                            <option
                                                key={res._id}
                                                value={JSON.stringify({ _id: res._id, bimonthly: res.bimonthly })}
                                            >
                                                {assessmentRegime === 'TRIMESTRAL'
                                                    ? res.bimonthly.replace('BIMESTRE', 'TRIMESTRE')
                                                    : res.bimonthly}
                                            </option>
                                        ))}
                                    <option value="FinalConcepts">Resultado Final</option>
                                </Select>
                            </FieldGroup>
                            <ModalActions>
                                <CancelButton onClick={() => setBimAllBull(false)}>Cancelar</CancelButton>
                            </ModalActions>
                        </Modal>
                    </Overlay>
                )}

            </ContainerDivs>
        </Container>
    )
}

export default Cla$$Info